module.exports = __webpack_public_path__ + "static/Lodging_AmericinnNorth-21b343c8790fe0609805f152c8019cf1.jpg";